import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Skeleton from '@material-ui/lab/Skeleton';
import styled from 'styled-components';

const QuantityBoxContainer = styled.div`
  width: ${props => props.theme.spacing(7)}px;
`;

const QuantityBoxSkeleton = ({ showLabel }) => (
  <QuantityBoxContainer>
    {showLabel && (
      <Box py={1}>
        <Skeleton />
      </Box>
    )}
    <Skeleton variant="rect" height={56} width={56} />
  </QuantityBoxContainer>
);

QuantityBoxSkeleton.propTypes = {
  showLabel: PropTypes.bool,
};

QuantityBoxSkeleton.defaultProps = {
  showLabel: true,
};

export default QuantityBoxSkeleton;
